import { Alert, Grid, Link, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import StatusAlert from '../components/elements/Alert';
import ForgotPasswordForm from '../components/forgot-password';
import AuthWrapper from '../layout/auth/auth-wrapper';
import { forgotPassword } from '../modules/users';

function ForgotPasswordPage() {
  const [error, setError] = useState(null);
  const [responseMessage, setResponseMessage] = useState(null);
  const [showResponse, setShowResponse] = useState(false);
  const navigate = useNavigate()
  const handleSubmit = async (values) => {
    setError(null);
    setResponseMessage(null);
    try {
      const { message } = await forgotPassword({ email: values.email });
      setResponseMessage(message);
      setShowResponse(true);
    } catch (err) {
      setError(err.message || 'Failed to reset password');
    }
  };
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const tokenData = JSON.parse(atob(token.split('.')[1]));
      const isTokenValid = Date.now() <= tokenData.exp * 1000;
      if (isTokenValid) {
        navigate('/dashboard', { replace: true });
      }
    }
  }, []);
  return (
    <AuthWrapper>
      <Grid container spacing={3} >
        {showResponse ? (
          <>
            <Grid item xs={12}>
              <StatusAlert
                status={{ message: responseMessage, type: 'success' }}
              />
            </Grid>
            <Grid item xs={12}>
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center">
                <Typography variant="h4" gutterBottom color="success.main">
                  Recovery link sent!
                </Typography>
                <Typography variant="subtitle2">
                  Now, check your email and follow the instructions
                </Typography>
              </Stack>
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12}>
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center">
                <Typography variant="h5" gutterBottom>
                  Forgot your password?
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12}>
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
              <ForgotPasswordForm onSubmit={handleSubmit} />
            </Grid>
          </>
        )}
        <Grid item xs={12} sx={{ textAlign: 'center' }}>
          <Link
            variant="body2"
            underline="none"
            component={RouterLink}
            to="/login"
            color="text.primary">
            <span>&#8592; Go back to login</span>
          </Link>
        </Grid>
      </Grid>
    </AuthWrapper>
  );
}

export default ForgotPasswordPage;
